import { render } from "./CreatePriceOffer.vue?vue&type=template&id=06b37d8d&scoped=true"
import script from "./CreatePriceOffer.vue?vue&type=script&lang=js"
export * from "./CreatePriceOffer.vue?vue&type=script&lang=js"

import "./CreatePriceOffer.vue?vue&type=style&index=0&id=06b37d8d&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b37d8d"]])

export default __exports__